import { type ICSVExport } from '@principle-theorem/ng-shared';
import { DAY_MONTH_YEAR_FORMAT, toMoment } from '@principle-theorem/shared';
import { type IPendingFollowUp } from './pending-follow-up';

export interface IPendingFollowUpCSV {
  patientName: string;
  practitionerName: string;
  treatmentCategory: string;
  followUpDate: string;
  lastContacted: string;
}

export class PendingFollowUpToCSV
  implements ICSVExport<IPendingFollowUp, IPendingFollowUpCSV>
{
  defaultFileName = 'follow-ups';
  headers = [
    'Patient',
    'Practitioner',
    'Treatment Category',
    'Follow Up Date',
    'Last Contacted',
  ];

  translate(records: IPendingFollowUp[]): IPendingFollowUpCSV[] {
    return records.map((record) => ({
      patientName: record.patient.name,
      practitionerName: record.appointment.practitioner.name,
      treatmentCategory: record.treatmentCategory?.name ?? '',
      followUpDate: record.appointment.activeFollowUp?.followUpDate
        ? toMoment(record.appointment.activeFollowUp.followUpDate).format(
            DAY_MONTH_YEAR_FORMAT
          )
        : '',
      lastContacted: record.lastContactedAt
        ? toMoment(record.lastContactedAt).format(DAY_MONTH_YEAR_FORMAT)
        : '',
    }));
  }
}
